import type { Product, ProductActionLog } from '@gozoki/api-types'
import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

// Fetch one product
export const fetchProduct = async (id: number) => {
  const response = await gozokiApi.get<Product>(`/products/${id}`)
  return response.data
}

// Fetch all products
export const fetchProducts = async () => {
  const response = await gozokiApi.get<Product[]>('/products')
  return response.data
}

export const fetchMultipleProducts = async (ids: number[]) => {
  const data = { ids }
  const response = await gozokiApiWithAuth.post<Product[]>('/products/show-multiple', data)
  return response.data
}

export const fetchProductsXlsx = async () => {
  const response = await gozokiApiWithAuth.get<Blob>('/products/export-xlsx', {
    responseType: 'blob',
  })

  return response.data
}

export const importProductsXlsx = async (file: File) => {
  const formData = new FormData()
  formData.append('importFile', file)

  const response = await gozokiApiWithAuth.post('/products/import-xlsx', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export const fetchProductActionLogs = async (productId: number) => {
  const res = await gozokiApiWithAuth.get<ProductActionLog[]>(`/products/${productId}/action-logs`)
  return res.data
}
